import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { getUserInfo, saveUserInfoInStorage } from '../../authentication/authenticationHelper';
import { AlertError } from '../../components/bootstrap/AlertError';
import Loading from '../../components/general/Loading';
import { SubTemplate } from '../../components/general/SubTemplate';
import {
  getCountiesByDistrictCode,
  getDistricts,
  getParishesByCountyCode
} from '../../rest/administrativeDivision';
import { listCountries } from '../../rest/country';
import { getPromoter, editPromoterAddress } from '../../rest/promoter';
import { handleError, isNotBusinessError } from '../../utils/handleError';
import { PromoterEditAddressForm } from '../../components/promoter/PromoterEditAddressForm';
import { FormattedMessage } from 'react-intl';
import { AlertSuccess } from '../../components/bootstrap/AlertSuccess';

export function EditPromoterAddress() {
  let userInfo = getUserInfo();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [promoter, setPromoter] = useState(null);
  const [countries, setCountries] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [counties, setCounties] = useState([]);
  const [parishes, setParishes] = useState([]);
  const [addressChanged, setAddressChanged] = useState(false);

  async function fetchData() {
    try {
      const [
        { data: promoter },
        { data: countries },
        { data: districts },
      ] = await Promise.all([
        await getPromoter(),
        await listCountries(),
        await getDistricts(),
      ]);
      setPromoter(await getPromoterFormValues(promoter));

      setCountries(countries);
      setDistricts(districts);
      
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  async function getPromoterFormValues(promoter) {
    if (promoter.parish) {
      await handleDistrictChange(promoter.parish.substring(0, 2));
      await handleCountyChange(promoter.parish.substring(0, 4));
    }



    const values = {

      country: promoter.country ? promoter.country : '-1',

      name: userInfo.name,

      city: promoter.city ? promoter.city : '',

      address: promoter.address ? promoter.address : '',

      district: promoter.parish ? promoter.parish.substring(0, 2) : '-1',

      county: promoter.parish ? promoter.parish.substring(0, 4) : '-1',

      parish: promoter.parish ? promoter.parish : '-1',

      postalCode: promoter.postalCode ? promoter.postalCode : '',

    };
    return values;
  }

  async function updatePromoter(values) {
    let dataToSend = {
      address: values.address,
      postalCode: values.postalCode,
      parish: values.parish
    };
    setAddressChanged(false);
    try {
      await editPromoterAddress(dataToSend);
      setAddressChanged(true);
    } catch (error) {
      setError(error);
    }
  }

  function handleSubmit(values) {
    updatePromoter(values);
  }

  async function handleDistrictChange(districtCode) {
    try {
      const { data: counties } = await getCountiesByDistrictCode(districtCode);
      setCounties(counties);
      setParishes([]);
    } catch (error) {
      setError(error);
    }
  }

  async function handleCountyChange(countyCode) {
    try {
      const { data: parishes } = await getParishesByCountyCode(countyCode);
      setParishes(parishes);
    } catch (error) {
      setError(error);
    }
  }

  if (loading) {
    return <Loading />;
  }

  if (error && isNotBusinessError(error)) {
    return handleError(error);
  }

  return (
    <SubTemplate>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-8 offset-lg-2 mb-5'>
            <AlertError error={error} />
            {addressChanged && (
              <AlertSuccess
                header={<FormattedMessage id='alert.header.promoterAddressChanged' />}
                message={<FormattedMessage id='alert.message.promoterAddressChanged' />}
              />
            )}
            <PromoterEditAddressForm
              promoter={promoter}
              countries={countries}
              districts={districts}
              counties={counties}
              parishes={parishes}
              handleDistrictChange={handleDistrictChange}
              handleCountyChange={handleCountyChange}
              onSubmit={handleSubmit}
              savePromoter={updatePromoter}
              setError={setError}
            />
          </div>
        </div>
      </div>
    </SubTemplate>
  );
}
